(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-seccion-razones-imagen"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRz(root) {
    var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-rz-toggle]'));
    var mq = window.matchMedia('(max-width: 749px)');
    toggles.forEach(function (btn) {
      var item = btn.closest('[data-rz-item]');
      if (!item) return;
      btn.addEventListener('click', function () {
        if (!mq.matches) return;
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
    function syncDesktop() {
      if (!mq.matches) {
        root.querySelectorAll('[data-rz-item].is-open').forEach(function (item) {
          item.classList.remove('is-open');
          var b = item.querySelector('[data-rz-toggle]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      }
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', syncDesktop);
    } else if (mq.addListener) {
      mq.addListener(syncDesktop);
    }
  }
  function initAll() {
    document.querySelectorAll('[data-rz-seccion]').forEach(initRz);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-seccion-testimonios-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTvCarrusel(root) {
    var viewport = root.querySelector('[data-tv-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-tv-slide]'));
    var prevBtn = root.querySelector('[data-tv-prev]');
    var nextBtn = root.querySelector('[data-tv-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-tv-dot]'));
    if (!viewport || !slides.length) return;

    var activeIndex = Math.min(1, slides.length - 1);

    function closestSlideIndex() {
      var center = viewport.scrollLeft + viewport.clientWidth / 2;
      var closest = 0;
      var closestDist = Infinity;
      slides.forEach(function (slide, i) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = activeIndex <= 0;
      if (nextBtn) nextBtn.disabled = activeIndex >= slides.length - 1;
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        var active = i === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function goTo(index, behavior) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      activeIndex = index;
      var slide = slides[index];
      var target = slide.offsetLeft + slide.offsetWidth / 2 - viewport.clientWidth / 2;
      target = Math.max(0, Math.min(viewport.scrollWidth - viewport.clientWidth, target));
      if (behavior === 'auto') {
        viewport.scrollLeft = target;
      } else if (typeof viewport.scrollTo === 'function') {
        viewport.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        viewport.scrollLeft = target;
      }
      updateArrows();
      updateDots();
    }

    var scrollFrame = null;
    viewport.addEventListener(
      'scroll',
      function () {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(function () {
          var closest = closestSlideIndex();
          if (closest !== activeIndex) {
            activeIndex = closest;
            updateArrows();
            updateDots();
          }
        });
      },
      { passive: true }
    );

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(activeIndex + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(activeIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(activeIndex + 1); }
    });

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      viewport.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!isDown) return;
      isDown = false;
      viewport.classList.remove('is-dragging');
      if (moved) {
        window.requestAnimationFrame(function () {
          goTo(closestSlideIndex(), 'smooth');
        });
      }
    });
    viewport.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );

    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-tv-clickzone] video'));
    function pauseAll(except) {
      videos.forEach(function (v) {
        if (v !== except) {
          v.pause();
        }
      });
    }
    videos.forEach(function (video) {
      var slide = video.closest('[data-tv-slide]');
      var clickzone = video.closest('[data-tv-clickzone]');
      if (!clickzone || !slide) return;
      clickzone.addEventListener('click', function () {
        if (video.paused) {
          pauseAll(video);
          video.muted = false;
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', function () { slide.classList.add('is-playing'); });
      video.addEventListener('pause', function () { slide.classList.remove('is-playing'); });
      video.addEventListener('ended', function () {
        if (!video.loop) slide.classList.remove('is-playing');
      });
    });

    window.requestAnimationFrame(function () { goTo(activeIndex, 'auto'); });
    window.addEventListener('resize', function () { goTo(activeIndex, 'auto'); });
  }

  function initAll() {
    document.querySelectorAll('[data-tv-seccion]').forEach(initTvCarrusel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
